import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SidebarComponent from '../common/sidebar-component';
import OrganisationResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import StockCode from '../common/sidebar/stock-code';
import useGetStockCodesUsedByOrganisation from '../../../services/stock-codes/stock-codes-used-by-organisation-service';

export default function TopStockCodes({ organisation }) {
  const { dispatch } = React.useContext(OrganisationResultsContext);
  const [{ data }, executeQuery] = useGetStockCodesUsedByOrganisation(organisation, 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'stockCodes.length')) {
      dispatch({ type: 'setStockCodes', payload: data.stockCodes });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'stockCodes.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title={`${data.stockCodes.length > 1 ? 'companies' : 'company'} mentioned by`}
        query={organisation}
      />
      {data.stockCodes.map(d => <StockCode key={`stock-code-${d.id}`} stockCode={d} />)}
    </SidebarComponent>
  );
}

TopStockCodes.propTypes = {
  organisation: PropTypes.string.isRequired,
};
